import { render, staticRenderFns } from "./DictDataModal.vue?vue&type=template&id=12e6758a&"
import script from "./DictDataModal.vue?vue&type=script&lang=js&"
export * from "./DictDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports